/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableHighlight, Image ,TouchableOpacity } from 'react-native'
import styles from './Styles/StaticInforComponentStyle'
import { Images } from '../Themes/'
import TextComponent from './TextComponent'
import I18n from "i18n-js"

export default class StaticInforComponent extends Component {

  kFormatter(num) {
    if (num === false || isNaN(num))
      return '0'
    else
      return parseInt(num) > 999 ? (parseInt(num) / 1000).toFixed(0) + 'k' : num
  }
  render() {
    const { views, loves, followers, following, isMyProfile, onFollowerPress,onFollowingPress } = this.props
    const viewMode = this.props.viewMode
    const modeIcon = viewMode == 'grid' ? Images.gridProfile : viewMode == 'list' ? Images.listProfile : Images.mosaicProfile
    return (

      <View style={[styles.statisticInfoContainer, { height: 60 }, this.props.style]}>
        <View style={styles.item}>
          <TextComponent text={this.kFormatter(views)} style={styles.smallFontSize} />
          <TextComponent text={I18n.t('followersProfile.views')} style={styles.fontSize} />
        </View>
        <View style={styles.item}>
          <TextComponent text={this.kFormatter(loves)} style={styles.smallFontSize} />
          <TextComponent text={I18n.t('followersProfile.loves')} style={styles.fontSize} style={styles.fontSize} />
        </View>
        <View style={styles.item}>
          <TouchableOpacity onPress={onFollowerPress}>
          <View  style={styles.item}>
              <TextComponent text={this.kFormatter(followers)} style={styles.smallFontSize} />
              <TextComponent text text={I18n.t('followersProfile.follower')} style={styles.fontSize} />
            </View>
          </TouchableOpacity >
        </View>
        <View style={styles.item}>
          <TouchableOpacity onPress={onFollowingPress}>
            <View  style={styles.item}>
              <TextComponent text={this.kFormatter(following)} style={styles.smallFontSize} />
              <TextComponent text={I18n.t('followersProfile.following')} style={styles.fontSize} />
            </View>
          </TouchableOpacity >
        </View>
        {isMyProfile && <View style={styles.item}>
          <TouchableHighlight
            onPress={this.props.onPress}
            underlayColor='grey'>
            <Image source={modeIcon} style={[styles.tconBorder]} />
          </TouchableHighlight>
        </View>
        }
      </View>

    )
  }
}
